import { Node, mergeAttributes, Command, RawCommands, ChainedCommands } from '@tiptap/core';

interface FormulaNodeCommands {
  setFormula: (attributes: Record<string, unknown>) => Command;
}

const FormulaNode = Node.create<FormulaNodeCommands>({
  name: 'formulaNode',
  group: 'inline',
  inline: true,
  selectable: true,

  addAttributes() {
    return {
      label: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-formula-node]',
        getAttrs: (element): Record<string, unknown> => {
          if (typeof element === 'string') return {};
          const label = element.getAttribute('data-label');
          return { label };
        },
      },
    ];
  },

  renderHTML({ node }) {
    const { label } = node.attrs;
    return [
      'span',
      mergeAttributes({
        'data-formula-node': '',
        'data-label': label as string,
        class:
          'px-2 py-1 mx-2 first:ml-0 rounded-full border border-neutral-100 bg-neutral-15 inline-block white-space-nowrap',
        role: 'math',
        'aria-label': `Formula: ${label}`,
      }),
      label,
    ];
  },

  addCommands() {
    return {
      setFormula:
        (attributes: Record<string, unknown>) =>
        ({ chain }: { chain: () => ChainedCommands }): boolean => {
          return chain()
            .insertContent({
              type: this.name,
              attrs: attributes,
            })
            .run();
        },
    } as Partial<RawCommands>;
  },
});

export default FormulaNode;
